import { useEffect } from "react";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import { Button } from "@/shared/ui";
import { HAIR_COLORS, HAIR_STYLE_KEYS } from "@/domains/createCharacter/constants/headOverlay";
import { nextStep, prevStep, setCorrectStep } from "@/domains/createCharacter/slice";
import useChangeHairStyle from "@/domains/createCharacter/hooks/useChangeHairStyle";
import useChangeHeadOverlay from "@/domains/createCharacter/hooks/useChangeHeadOverlay";
import CreateCharacterSetContainer from "@/domains/createCharacter/containers/CreateCharacterSetContainer";
import CreateCharacterColorSwitcher from "@/domains/createCharacter/components/CreateCharacterColorSwitcher";
import CreateCharacterScrollArea from "@/domains/createCharacter/components/CreateCharacterScrollArea";
import CreateCharacterStepHeader from "@/domains/createCharacter/components/CreateCharacterStepHeader";
import CreateCharacterVariantSelect from "@/domains/createCharacter/components/CreateCharacterVariantSelect";

export default function CreateCharacterHairStyleContainer() {
  const dispatch = useAppDispatch();
  const {
    config,
    hair,
    onChangeHair,
    onChangeHairColor,
    onChangeHairHighlightColor,
    randomizeAll,
  } = useChangeHairStyle();
  const { onChange } = useChangeHeadOverlay();

  useEffect(() => {
    dispatch(setCorrectStep({ step: 3, isCorrect: true }));
  }, [dispatch]);

  return (
    <>
      <CreateCharacterStepHeader title="Прическа" onRandom={randomizeAll} />
      <CreateCharacterScrollArea>
        {!!config?.hairs?.length && (
          <>
            <CreateCharacterVariantSelect
              label="Прическа"
              value={hair.drawableId}
              valueDefault={0}
              valueTitle={(value) => config.hairs.find((item) => item === value) || "Нет"}
              variants={config.hairs}
              onChange={onChangeHair}
            />
            <CreateCharacterColorSwitcher
              label="Основной цвет"
              variants={HAIR_COLORS}
              value={hair.color}
              onChange={onChangeHairColor}
            />
            <CreateCharacterColorSwitcher
              label="Доп. цвет"
              variants={HAIR_COLORS}
              value={hair.highlightColor}
              onChange={onChangeHairHighlightColor}
            />
          </>
        )}

        {HAIR_STYLE_KEYS.map((feature) => (
          <CreateCharacterSetContainer key={feature} feature={feature} onChange={onChange} />
        ))}
      </CreateCharacterScrollArea>
      <div className="grid grid-cols-2 items-center gap-2.5 pt-2 mt-auto">
        <Button variant="solid-surface-gradient" onClick={() => dispatch(prevStep())}>
          Назад
        </Button>
        <Button onClick={() => dispatch(nextStep())}>Далее</Button>
      </div>
    </>
  );
}
